import React from "react";

import './styles.css'
import {
    Box,
    IconButton,
    TextField,
    Typography,
    Grid,
    Stack,
    Button
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ViewAllExercises from "../planos/ViewAllExercises";

import { LoadingButton } from '@mui/lab';


function AddPopUp(props){
 
  return (props.trigger) ? (
    <Box className="popup" >
        <Box className="popup-inner"  >
        <Typography variant="h6">Criar Novo Plano de Sessão</Typography>
            <Grid container spacing={1.5}>
              <Grid item xs={5} md={5} lg={5} >
                  <TextField fullWidth label="Nome do Plano" />
              </Grid>
              <Grid item xs={7} md={7} lg={7} >
                <TextField multiline fullWidth rows={1}label="Descrição" />
              </Grid>
              
              <Grid item xs={12} md={12} lg={12} >
              <Typography variant="subtitle1">Escolher exercícios...</Typography>
                <Stack direction="row" spacing={1} sx={{alignItems:'center'}}>  
                 
                  <ViewAllExercises/>

                </Stack>
              </Grid>
              
            </Grid>

            <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={() => props.setTrigger(false)}>
                Confirmar seleção
            </LoadingButton>
            
            
            <IconButton className="close-btn" onClick={() => props.setTrigger(false)}>
                <CloseIcon/>
            </IconButton>
            {props.children}
        </Box>
    </Box>
  ) : "";
}
export default AddPopUp
